/**
 * Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import axios from "axios";

import { errorHandler, options } from "./index";
// import history from '../history/index';
import types from "../actions/types";
import { API_URL } from "../config";
import { toast_notifications } from "../utils/notifications";
// import STATIC_ROUTES from '../route/STATIC_ROUTES';

export function postAllTermsVersion() {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/termsVersion/postAllTermsVersion", {}, "post")
      );
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        dispatch({
          type: types.GET_ALL_TERMS_VERSION,
          payload: response.data,
        });
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function postOnlyTermsVersion() {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/termsVersion/postOnlyTermsVersion", {}, "post")
      );
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        dispatch({
          type: types.GET_ALL_TERMS_VERSION,
          payload: response.data,
        });
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function createTermsVersion(body) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/termsVersion/createTermsVersion", body, "post")
      );
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        toast_notifications.success("Terms version was successfully created!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

// Just initialisation
export function updateTermsVersion(data) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/termsVersion/updateTermsVersion", data, "put")
      );

      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        toast_notifications.success("Terms version was successfully updated!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function updateTermsVersionStatus(data) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/termsVersion/updateTermsVersionStatus", data, "put")
      );
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        toast_notifications.success("Version Status successfully changed!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function updateTermsVersionFreeze(data) {
  return async (dispatch) => {
    try {
      await axios(options(API_URL + "/termsVersion/updateTermsVersionFreeze", data, "put"));
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function updateTermsVersionActive(data) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/termsVersion/updateTermsVersionActive", data, "put")
      );

      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        toast_notifications.success("Terms version status was successfully changed!");
      }
      if (response.data.message) {
        const reponseMessage = response.data.message;
        toast_notifications.warning(reponseMessage);
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function getTermsById(body) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/termsVersion/getTermsById", body, "post"));
      return response.data;
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function deleteTermsVersionById(body) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/termsVersion/deleteTermsVersion", body, "delete")
      );
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        toast_notifications.success("Term version was successfully deleted!");
      }
    } catch (error) {
      console.log(error);
      dispatch(errorHandler(error));
    }
  };
}

export function sendEmailForExamination(body) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/termsVersion/sendMailForExamination", body, "post")
      );
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        // dispatch(actions.showNotification("Successfully deleted term!", true));
        toast_notifications.success("Email for examination was successfully send!");
      }
    } catch (error) {
      console.log(error);
      dispatch(errorHandler(error));
    }
  };
}
